import { useState, useEffect } from 'react'
import api from '../../../utils/api'

// <img src="..."> não consegue mandar o header Authorization, e a rota /images
// exige login. Este componente busca a imagem via axios (que já manda o token)
// e converte a resposta num object URL local pro <img> exibir.
function AuthImage({ src, alt, className, onClick }) {
    const [objectUrl, setObjectUrl] = useState(null)

    useEffect(() => {
        if (!src) {
            setObjectUrl(null)
            return
        }

        let cancelled = false
        let currentUrl = null
        const token = localStorage.getItem('token')

        api.get(src, {
            responseType: 'blob',
            headers: token ? { Authorization: `Bearer ${JSON.parse(token)}` } : {},
        }).then((response) => {
            if (cancelled) return
            currentUrl = URL.createObjectURL(response.data)
            setObjectUrl(currentUrl)
        }).catch(() => {
            if (!cancelled) setObjectUrl(null)
        })

        return () => {
            cancelled = true
            if (currentUrl) URL.revokeObjectURL(currentUrl)
        }
    }, [src])

    if (!objectUrl) return null

    return <img src={objectUrl} alt={alt} className={className} onClick={onClick} />
}

export default AuthImage
